<template>
    <div class="mb-5">
        <h4 class="mb-3">Leads</h4>

        <div class="row report-row">
            <div class="col-4">
                Leads ordered
            </div>
            <div class="col-6">
                <template v-if="readonly">
                    {{ fulfillment.leads_ordered }}
                </template>
                <template v-else>
                    <el-input v-model="fulfillment.leads_ordered"></el-input>

                    <div class="mt-2">
                        <btn :click="save" v-if="! readonly">Save</btn>
                    </div>
                </template>
            </div>
        </div>
        <div class="row report-row">
          <div class="col-4">
            Pacing
          </div>
          <div class="col-6">
            <el-switch
                v-model="fulfillment.daily_pacing"
                active-text="Daily Pacing"
                inactive-text="No Pacing"
                @input="updateDailyPacing">
            </el-switch>
          </div>
        </div>
        <div class="row report-row">
            <div class="col-4">
                Leads delivered
            </div>
            <div class="col-6">
                {{ fulfillment.leads_delivered }}
            </div>
        </div>
        <div class="row report-row">
            <div class="col-4">
                Leads needed
            </div>
            <div class="col-6">
                {{ leadsNeeded }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'fulfillment',
            'readonly',
        ],
        computed: {
            leadsNeeded() {
                let leadsNeeded = this.fulfillment.leads_ordered - this.fulfillment.leads_delivered;
                if(leadsNeeded > 0) {
                    return leadsNeeded;
                }

                return 0;
            },
        },
        methods: {
            updateDailyPacing() {
                return axios.post(url(`de/fulfillment/${this.fulfillment.id}/pacing`), {
                    pacing: this.fulfillment.daily_pacing
                }).then((response) => {
                    this.$emit('changed');
                });
            },
            save() {
                return axios.post(url(`de/fulfillment/${this.fulfillment.id}/leads`), {
                    leads_ordered: this.fulfillment.leads_ordered
                }).then((response) => {
                    this.$emit('changed');
                });
            },
        },
    }
</script>

<style scoped>
    div .report-row {
        margin-bottom: 10px;
    }
</style>
